import api from "./api";

export async function getProjectIntelligence(projectId) {
    const res = await api.get(`/crm/projects/${projectId}/intelligence`);
    return res.data;
}